/**
 * Home Feature Model
 * Data structures for the home feature
 */

import type { Contact } from "../../../api/types";

export interface HomeConfig {
  title?: string;
  appName?: string;
  logo?: string;
}

export const defaultHomeConfig: HomeConfig = {
  title: "Contacts",
};

// Re-export Contact for convenience
export type { Contact };
